import React from 'react';
import { useGetStarted } from './GetStartedContext';
import QuestLabs from '../../../../components/QuestLabs';

const Footer: React.FC = () => {
  const { themeManager } = useGetStarted();

  return (
    <div>
      <QuestLabs
        style={themeManager.getFooterStyles().container}
        textStyle={themeManager.getFooterStyles().text}
        iconStyle={themeManager.getFooterStyles().icon}
      />
    </div>
  );
};

export default Footer;